import { useTranslation } from "react-i18next";

import { RECALL_TYPE } from "components";
import { generateDMSNr } from "utils/appointmentUtils";

import type { RecallEntity } from "models";
import type { AddInterventionPayload } from "modules/AppointmentDetails/hooks";

export const useConvertRecallToIntervention = (appointmentId: number) => {
  const { t } = useTranslation();

  const convertRecallToIntervention = (recall: RecallEntity, recallType: RECALL_TYPE): AddInterventionPayload => {
    let title = "";
    let field = "";

    if (recallType === RECALL_TYPE.DistrimateRecall) {
      title = `${t("v8_recall", "Recall")} ${recall.campaign_code}`;
      field = "recalls_id";
    } else if (recallType === RECALL_TYPE.RDWRecall) {
      title = `${t("v8_rdw_recall", "RDW Recall")} ${recall.id}`;
      field = "rdw_recall_id";
    } else {
      title = `${t("v8_recall", "Recall")} ${recall.id}`;
      field = "pon_recall_id";
    }

    const newIntervention = {
      customer_ok: false,
      appointment_id: appointmentId,
      dms_nr: generateDMSNr(),
      visible_to_customer: true,
      [field]: recall.id,
      title,
      description: recall.campaign_name,
      reference_nr: generateDMSNr(),
      price: 0
    };

    return newIntervention;
  };

  return { convertRecallToIntervention };
};
